/**
 * @flow
 * @relayHash ace17b506d9366596843ab74f90f4c52
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConfirmPhoneVerificationInput = {|
  phone: string,
  code: string,
|};
export type ConfirmPhoneVerificationMutationVariables = {|
  input: ConfirmPhoneVerificationInput
|};
export type ConfirmPhoneVerificationMutationResponse = {|
  +confirmPhoneVerification: {|
    +user: {|
      +id: string,
      +phone: ?string,
      +phoneVerified: boolean,
      +twoFactorEnabled: boolean,
    |}
  |}
|};
export type ConfirmPhoneVerificationMutation = {|
  variables: ConfirmPhoneVerificationMutationVariables,
  response: ConfirmPhoneVerificationMutationResponse,
|};
*/


/*
mutation ConfirmPhoneVerificationMutation(
  $input: ConfirmPhoneVerificationInput!
) {
  confirmPhoneVerification(input: $input) {
    user {
      id
      phone
      phoneVerified
      twoFactorEnabled
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConfirmPhoneVerificationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "confirmPhoneVerification",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfirmPhoneVerificationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phoneVerified",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "twoFactorEnabled",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ConfirmPhoneVerificationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ConfirmPhoneVerificationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ConfirmPhoneVerificationMutation",
    "id": null,
    "text": "mutation ConfirmPhoneVerificationMutation(\n  $input: ConfirmPhoneVerificationInput!\n) {\n  confirmPhoneVerification(input: $input) {\n    user {\n      id\n      phone\n      phoneVerified\n      twoFactorEnabled\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b1f58720b3d6dec7d717597216354238';
module.exports = node;
